import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  withMarginBottom: {
    marginBottom: theme.spacing(2),
  },
  withMarginBottomMobile: {
    marginBottom: 0,
    padding: '0 !Important',

    '@media(min-width: 768px)': {
      marginBottom: 0,
      marginTop: 0,
      padding: '0 8px !important',
    },
  },
  media: {
    height: 240,
    borderRadius: 4,
  },
  box: {
    boxShadow:
      '0px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: 16,
    backgroundColor: '#FFF',

    '@media(min-width: 768px)': {
      padding: 24,
      marginBottom: theme.spacing(3),
    },
  },
  steps: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: theme.spacing(5),
  },
  stepsItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 52,
    position: 'relative',

    '&:before': {
      content: '""',
      position: 'absolute',
      width: 20,
      height: 1,
      right: -32,
      display: 'block',
      top: 'calc(50% - 1px)',
      backgroundColor: theme.palette.primary.disabled,
    },
    '&:last-of-type': {
      marginRight: 0,
      '&:before': {
        display: 'none',
      },
    },
  },
  stepsCount: {
    backgroundColor: theme.palette.primary.disabled,
    borderRadius: '50%',
    minWidth: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    position: 'relative',
  },
  stepsCountSelected: {
    backgroundColor: theme.palette.action.active,
    marginRight: theme.spacing(1),
  },
  stepsDescription: {
    fontSize: '1rem',
  },
  filterForm: {
    marginBottom: theme.spacing(2),

    '@media(min-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  marginMobile: {
    '@media(max-width: 768px)': {
      marginBottom: theme.spacing(4),
    },
  },
  submit: {
    float: 'right',
  },
  mediaDesktop: {
    height: 345,
    borderRadius: 4,
    position: 'relative',

    '&:after': {
      content: '""',
      position: 'absolute',
      borderRadius: 4,
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      background: 'linear-gradient(0deg, rgba(0,0,0,.8), rgba(0,0,0,0) 100%)',
    },
  },
  projectHeaderDesktop: {
    color: theme.palette.primary.contrastText,
    position: 'absolute',
    bottom: 40,
    left: 40,
  },
  subTitle: {
    fontSize: '3em',
    marginBottom: 32,
    textAlign: 'center',
  },
  formTitle: {
    fontSize: '2em',
    marginBottom: 16,
    color: theme.palette.primary.main,

    '@media(min-width: 768px)': {
      marginTop: 24,
    },
  },
  marginCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 32,

    '@media(min-width: 768px)': {
      marginTop: 40,
    },
  },
  tooltip: {
    fontSize: '1rem',
    lineHeight: '150%',
  },
  tooltipIcon: {
    position: 'absolute',
    top: 'calc(50% - 8px)',
    left: 'calc(100% + 24px)',
    fontSize: '1.3rem',
  },
  votesList: {
    marginBottom: 24,
  },
  votesListItem: {
    display: 'flex',
    marginBottom: 16,
  },
  votesIcon: {
    marginRight: 8,
  },
  chipsList: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    padding: '16px 0',
    alignItems: 'center',
  },
  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.primary.contrastText,
    maxWidth: '100%',
  },
  agreement: {
    marginTop: theme.spacing(2.5),

    '@media(min-width: 768px)': {
      marginTop: theme.spacing(4),
    },
  },
  warning: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(3),
  },
  warningNoMargin: {
    color: theme.palette.error.main,
  },
  forceh5: {
    fontSize: '1.5rem',
    fontWeight: 400,
  },
}));
